<app-internal-page>
    <div content *ngIf="scheduleResponseData">
        
        <div fxLayout="column" fxLayoutGap="25px" fxLayoutGap.xs="20px">

            <div fxLayoutAlign="center center">
                <label class="mat-title">Agendamento confirmado!</label>
            </div>
            <mat-card>
                <mat-card-content>
                    <div class="confirmation-container" fxLayout="row" fxLayoutAlign="start center">
                        <div fxLayout="column" fxLayoutGap="3px">
                            <span class="mat-subheading-2">
                                {{scheduleResponseData.schedule_start | date: 'dd/MM/yyyy, EEEE, HH:mm'}}
                            </span>
                            <span class="mat-subheading-1">
                                {{scheduleResponseData.dentist.name}}
                                <span *ngIf="scheduleResponseData.dentist.specialty">
                                    - {{scheduleResponseData.dentist.specialty}}
                                </span>
                            </span>
                            <span class="mat-subheading-1">
                                {{getScheduleTypeName()}}
                            </span>
                            <span class="mat-subheading-1">
                                {{scheduleResponseData.customer.name}}
                            </span>
                            <span class="mat-subheading-1" *ngIf="scheduleResponseData.customer.cellphone">
                                {{scheduleResponseData.customer.cellphone | mask:'(00) 00000 - 0000'}}
                            </span>
                            <span class="mat-subheading-1">
                                {{scheduleResponseData.clinic.name}}
                            </span>
                            <span class="mat-subheading-1" *ngIf="getClinicAddressFormated()">
                                {{getClinicAddressFormated()}}
                            </span>
                        </div>
                    </div>
                    <div><mat-divider></mat-divider></div>
                    <div class="warn-container" fxLayout="column" fxLayoutGap="5px" fxLayoutAlign="center start">
                        <div fxLayoutGap="10px" fxLayoutAlign="start start">
                            <span class="icon fa fa-check"></span>
                            <label>Aguardamos você no dia e horário definidos</label>
                        </div>
                        <div fxLayoutGap="10px" fxLayoutAlign="start start">
                            <span class="icon fa fa-check"></span>
                            <label>Lembrar de chegar 10 minutos antes</label>
                        </div>
                        <div fxLayoutGap="10px" fxLayoutAlign="start start">
                            <span class="icon fa fa-check"></span>
                            <label>No caso de remarcação, avisar previamente</label>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <button mat-raised-button color="primary" (click)="onNewScheduleClick()">
                Realizar outro agendamento
            </button>
        </div>
    </div>
</app-internal-page>